export function calculateProgressPercent(done: number, total: number): number {
  if (total <= 0) {
    return 0;
  }
  return Math.min(Math.max((done / total) * 100, 0), 100);
}
